// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/app';

// ----------------------------------------------------------------------
export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  resetPassword2: path(ROOTS_AUTH, '/reset-password-t/:token'),
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  // FoldOUT STUDENT TABS
  admin: {
    tabEditorOverview: path(ROOTS_DASHBOARD, '/a/tabeditor'),
    locationEditor: path(ROOTS_DASHBOARD, '/a/locationeditor'),
    tabEditor: path(ROOTS_DASHBOARD, '/a/tabeditor/:tabId'),
    newUser: path(ROOTS_DASHBOARD, '/a/newuser'),
    employeeOverview: path(ROOTS_DASHBOARD, '/a/employees'),
    exportPortal: path(ROOTS_DASHBOARD, '/a/exports'),
    financeOverview: path(ROOTS_DASHBOARD, '/a/finances'),
    budgets: path(ROOTS_DASHBOARD, '/a/budgets')
  },
  employee: {
    dashboard: path(ROOTS_DASHBOARD, '/e/dashboard'), // stats + leerlingenoverview
    students: {
      root: path(ROOTS_DASHBOARD, '/e/students'), // stats + leerlingenoverview
      // new: path(ROOTS_DASHBOARD, '/e/studentsnew'),
      details: path(ROOTS_DASHBOARD, '/e/students/:id'), // stats + leerlingenoverview
      tab: path(ROOTS_DASHBOARD, '/e/students/:id/tabs/:tabid'), // stats + leerlingenoverview
    },
    password: path(ROOTS_DASHBOARD, '/e/password'),
    tagManagement: path(ROOTS_DASHBOARD, '/e/tagmanagement'),
    studentCreator: path(ROOTS_DASHBOARD, '/e/newstudent'),
    mfa: path(ROOTS_DASHBOARD, '/e/mfa'), // stats + leerlingenoverview
    projects: path(ROOTS_DASHBOARD, '/e/projects'),
    projectsView: path(ROOTS_DASHBOARD, '/e/projects/:id'),
    projectsEvent: path(ROOTS_DASHBOARD, '/e/projects/:project_id/events/:event_id'),
    projectsEdit: path(ROOTS_DASHBOARD, '/e/projects/:id/edit'),
    projectsNew: path(ROOTS_DASHBOARD, '/e/projects/new'),
    chat: path(ROOTS_DASHBOARD, '/e/chat/'),
    docs: path(ROOTS_DASHBOARD, '/e/docs/')
  },
  student: {
    settings: path(ROOTS_DASHBOARD, '/s/settings'),
    dashboard: path(ROOTS_DASHBOARD, '/s/dashboard'), // stats + when first signin complete profile, finance
    taboverview: path(ROOTS_DASHBOARD, '/s/tabs'), // stats + when first signin complete profile, finance
    financial: path(ROOTS_DASHBOARD, '/s/finances'),
    projects: path(ROOTS_DASHBOARD, '/s/projects'),
    projectsView: path(ROOTS_DASHBOARD, '/s/projects/:id'),
    chat: path(ROOTS_DASHBOARD, '/s/chat/'),
    documents: path(ROOTS_DASHBOARD, '/s/documents'),
    dataSharing: path(ROOTS_DASHBOARD, '/s/data-sharing')
  },
};
